import styled from 'styled-components';
import Paragraph from 'common/components/TouchpointEditor/components/TouchpointNodes/Paragraph';

export default styled(Paragraph)`
    padding-bottom: 3.5rem;
`;
